// frontend/src/components/HelpModal.jsx

import React from 'react';
import '../design-system.css';

const HelpModal = ({ show, onClose, content }) => {
  if (!show) {
    return null;
  }

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="modal-content"
        onClick={e => e.stopPropagation()}
        style={{ width: '80%', maxWidth: '700px', height: '80vh', display: 'flex', flexDirection: 'column' }}
      >
        <h2 style={{ marginTop: 0, fontSize: '18px', fontWeight: 600, color: 'var(--ds-txt)', borderBottom: '0.5px solid var(--ds-border)', paddingBottom: '12px' }}>
          Guida Rapida
        </h2>
        <div style={{
          flex: 1,
          overflowY: 'auto',
          whiteSpace: 'pre-wrap',
          fontFamily: 'var(--ds-font-mono)',
          fontSize: '13px',
          color: 'var(--ds-txt)',
          backgroundColor: 'var(--ds-surface-2)',
          border: '0.5px solid var(--ds-border)',
          padding: '16px',
          borderRadius: 'var(--ds-radius-sm)',
          marginTop: '16px',
        }}>
          {content ? content : "Caricamento della guida..."}
        </div>
        <button onClick={onClose} className="ds-btn" style={{ marginTop: '20px', alignSelf: 'flex-end' }}>
          Chiudi
        </button>
      </div>
    </div>
  );
};

export default HelpModal;
